import { styled } from 'core'

export const ControlsWrapper = styled('div')`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 12px;
    margin-bottom: 11px;
    justify-content: center;
`
